import React, {Fragment} from 'react'
import Credit from './Credit'
import NewCredit from './NewCredit'
import NewDebit from './NewDebit'
import Payment from './Payment'
import Debit from './Debit'
import HistoryModal from './HistoryModal'
import useModal from '../hooks/useModal'
import Group from './Group'
import NewTextMessage from './NewTextMessage'
import Service from './Service'
import PaymentRule from './PaymentRule'
import PaymentDetail from './PaymentDetail'
import NewUser from './NewUser'
import NewService from './NewService'
import NewPaymentRule from './NewPaymentRule'
import NewPaymentDetail from './NewPaymentDetail'
import NewGroup from './NewGroup'
import NewAccount from './NewAccount'
import TextMessage from './TextMessage'
import BankImport from './BankImport'
import NewBankImport from './NewBankImport'
import {createContext} from 'react'

export const ModalContext = createContext(false)

const MODAL_COMPONENTS = {
  'new-credit': NewCredit,
  'new-debit': NewDebit,
  'new-text-message': NewTextMessage,
  'new-user': NewUser,
  'new-service': NewService,
  'new-payment-rule': NewPaymentRule,
  'new-payment-detail': NewPaymentDetail,
  'new-group': NewGroup,
  'new-account': NewAccount,
  'new-bank-import': NewBankImport,
  'payment-rule': PaymentRule,
  'payment-detail': PaymentDetail,
  'bank-import': BankImport,
  'text-message': TextMessage,
  credit: Credit,
  debit: Debit,
  payment: Payment,
  history: HistoryModal,
  group: Group,
  service: Service
}

export default () => {
  const {modalStack} = useModal()
  if (modalStack.length === 0) return null

  return (
    <Fragment>
      {modalStack.map((name, index) => {
        const ModalComponent = MODAL_COMPONENTS[name]
        if (!ModalComponent) return null

        return (
          <ModalContext.Provider key={`${name}-${index}`} value={true}>
            <ModalComponent />
          </ModalContext.Provider>
        )
      })}
    </Fragment>
  )
}
